import React, { Component } from 'react'
import { Modal, Table, Button } from 'hljd'
import columns from './columns'
import store from '../store'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'

@observer
export default class extends Component {
  render() {
    const { modal, list, loading } = store
    return (
      <Modal
        title={modal.title}
        visible={modal.visible}
        onCancel={store.cancel}
        width={830}
        style={{ left: 110, top: 200 }}
        footer={[
          <Button key="back" type="ghost" onClick={store.cancel}>
            关闭
          </Button>
        ]}
      >
        <Table
          bordered
          dataSource={toJS(list)}
          columns={columns}
          loading={loading}
          pagination={false}
        />
      </Modal>
    )
  }
}
